import * as actionTypes from "./actionTypes";

export const initialState = {
  modalType: null,
  payload: null,
};

export default (state, action) => {
  switch (action.type) {
    case actionTypes.OPEN_MODAL:
      return {
        modalType: action.modalType,
        payload: action.payload,
      };
    case actionTypes.CLOSE_MODAL:
      return initialState;
    default:
      return state;
  };
};
